import { BaseConfigState } from '../../reducers/common/base-config';

export const shouldShowAccountMenu = (baseConfig: BaseConfigState) => {
    return ['MyPerformanceMetrics', 'ManageAdsPro'].includes(baseConfig.pageType);
};

export const switchAccount = async (accountId: string) => {
    const response = await fetch(`/bff-api/account/switch-account?selectedAccountId=${accountId}`);
    if (response.ok) {
        const url = new URL(window.location.href);
        url.search = '';
        window.location.href = url.toString();
    }
};
